import styled from "styled-components";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export const StyledFooter = styled(Col)`

  @media (max-width: 500px) {
    text-align: center;
  
}


`



export const StyledUlList = styled.ul`
  flex-direction: row;
  display: flex;
  list-style: none;
  padding: 0.25rem !important;
  margin: 0px;
  justify-content: start;

  svg {
    color: #354052;
    margin: 0px 15px 0px 0px;
  }
  @media (max-width: 500px) {
    justify-content: center;
    display: flex;
    margin-top: 20px;
    margin-left: 28px;
  }
`;

export const StyledFooterCopyRight = styled.p`
  font-size: 14px;
  line-height: 17px;
  color: #354052;
  @media (max-width: 500px) {
    justify-content: center;
    display: flex;
    padding-left: 15px;
  }
`;

export const StyledRowFooter = styled(Row)`
.ReactModalPortal .ReactModal__Overlay .ReactModal__Overlay--after-open {
  position: fixed;
  inset: 0px;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 99999999 !important;
}
    flex-direction: row;
    display: flex;
    padding: 0.25rem !important;
    margin: 0px;
    justify-content: flex-end;

    .col-creditos {
      padding-right: 0px;
      @media (max-width: 500px) {
        justify-content: center;
        display: flex;
        margin-top: 20px;
        padding-left: 15px;
      }
    }
    
  .styledUlSocial {
    flex-direction: row;
    display: flex;
    list-style: none;
    padding: 0.25rem !important;
    margin: 0px;
    justify-content: flex-end;

    a {
      padding: 0.5rem !important;
    }

    img {
      width: 30px;
    }

    @media (max-width: 768px) {
      li {
        padding-right: 10px;
      }
    }
    @media (max-width: 500px) {
      justify-content: center;
      margin-top: 20px;
    }
  }

  .styledSupport {
    flex-direction: row;
    display: flex;
    list-style: none;
    padding: 0.25rem !important;
    margin: 0px;
    justify-content: flex-end;
    align-items: center;

    .sumate,
    .creditos {
      background: #dc4157;
      font-size: 17px;
      font-weight: 700;
      border-radius: 12px;
      cursor: pointer;
      padding: 10px 0px;
      .link-sumate,
      .link-modal {
        color: #fff;
        padding: 10px 62px;
      }
    }

    .styleUlCredits {
      font-size: 16px;
      -webkit-columns: 2;
      -moz-columns: 2;
      columns: 2;
      li {
        line-height: 40px;
        list-style: none;
      }

      @media (max-width: 500px) {
        margin-bottom: 0;
        columns: 1;
        li {
          font-size: 12px;
        }
      }
    }
  }
`;
